<ng-container *transloco="let t">
  @if(searchModel || (filterTags!= undefined && !areFiltersEmpty) ||
  withTopRightMenu) {
  <section
    class="page-component-actions"
    [ngClass]="{ 'no-padding': isPricesPage }"
  >
    <div class="page-component-filters-row">
      <div style="display: flex; align-items: center">
        @if(searchModel){
        <div class="page-component-filters-search">
          <mc-input
            label=""
            icon="magnifying-glass"
            [value]="initialSearchValue"
            placeholder="{{ searchModel.placeholder }}"
            (input)="searchedTrigger($event)"
            fit="small"
            [clearbutton]="searchWithClear"
            (clearbuttonclick)="onClearSearchClick($event)"
          ></mc-input>
        </div>
        } @if(filterTags!= undefined && !areFiltersEmpty){
        <mc-drawer
          slot="trigger"
          style="padding-left: 10px"
          (closed)="onFilterDrawerClosed()"
          (opened)="onFilterDrawerOpened()"
          [class]="extraCssClasses"
        >
          <span slot="heading">{{ t("filters") }}</span>
          <ng-content select=".filter-content-injector"></ng-content>
          <mc-button
            slot="footer"
            dialogaction="close"
            (click)="onFilterApplied()"
            [disabled]="!filtersToApply || filtersToApply.length === 0"
            >Apply Filters</mc-button
          >
          <mc-button
            slot="footer"
            dialogaction="close"
            appearance="neutral"
            variant="outlined"
            (click)="onFilterCleared()"
            >Clear Filters</mc-button
          >
        </mc-drawer>
        <mc-button
          slot="trigger"
          [label]="t('filters')"
          icon="sliders-horizontal"
          appearance="neutral"
          fit="small"
          (click)="toggleDrawer()"
        ></mc-button>
        }
      </div>
      @if(withTopRightMenu) {
      <div class="page-component-top-right-menu">
        <mc-popover
          preventcloseonblur
          position="bottom-left"
          fit="small"
          class="menu-top-right-popover"
        >
          <mc-button
            fit="small"
            slot="trigger"
            appearance="neutral"
            variant="outlined"
            [disabled]="topRightMenuButtonDisabled"
          >
            {{ t("export_xlsx") }}
          </mc-button>
          <mc-list (listchange)="onTopRightMenuClick($event)" fit="small">
            <mc-list-item
              value="1"
              icon="tray-arrow-up"
              [label]="t('export_full_list')"
              [class]="
                topRightMenuDisabledOptionsValues.includes('1')
                  ? 'option-not-clicable'
                  : ''
              "
            ></mc-list-item>
            <mc-list-item
              value="2"
              icon="tray-arrow-down"
              [label]="t('export_based_on_filters')"
              [class]="
                topRightMenuDisabledOptionsValues.includes('2')
                  ? 'option-not-clicable'
                  : ''
              "
            ></mc-list-item>
          </mc-list>
        </mc-popover>
      </div>
      }
    </div>
  </section>
  <div
    class="page-component-filters-tag-body"
    [ngClass]="{
      'no-padding': isPricesPage && filterTags!.length > 0,
    }"
  >
    @for(tag of filterTags; track $index){ @if (tag.includes('+') &&
    filterTagTooltips[tag]) {
    <mc-tooltip
      [opendelay]="50"
      appearance="neutral-default"
      [zindex]="99999"
      style="padding-right: 4px"
    >
      <mc-tag
        slot="trigger"
        [label]="tag"
        appearance="info"
        class="page-component-filters-tooltip-tag"
        (dismiss)="tagCleared($event)"
        withaction
      ></mc-tag>
      <span>{{ filterTagTooltips[tag] }}</span>
    </mc-tooltip>
    } @else {
    <mc-tag
      style="padding-right: 4px; padding-bottom: 2px"
      [label]="tag"
      appearance="info"
      class="page-component-filters-tag"
      (dismiss)="tagCleared($event)"
      withaction
    ></mc-tag>
    } } @if(filterTags && filterTags.length > 0){
    <mc-button
      class="clear-filters-button"
      slot="trigger"
      [label]="t('clear_filters')"
      appearance="neutral"
      variant="plain"
      fit="small"
      (click)="onFilterTagCleared()"
    ></mc-button>
    }
  </div>
  }</ng-container
>
<router-outlet></router-outlet>
